// import global from './global';
import app from './app';
import user from './user';

let isHistoryApi = !!(window.history && history.pushState);

export default {
    // todo
    mode: isHistoryApi ? 'history' : 'hash',
    linkActiveClass: 'is-active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '/login',
            component: require('../views/Login'),
            meta: {
                label: '登录',
                hidden: true
            }
        },
        // {
        //     path: '/',
        //     component: require('../views/Home'),
        //     redirect: {
        //         name: 'TopicList'
        //     },
        //     meta: {
        //         label: '首页',
        //         hidden: true
        //     }
        // },
        // global,
        app,
        user,
        {
            path: '/',
            redirect: '/app/topic-list',
            meta: {
                hidden: true
            }
        },
        {
            path: '*',
            redirect: '/404',
            meta: {
                hidden: true
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./src/router/index.js